import $ from 'jquery';
import 'magnific-popup/dist/jquery.magnific-popup';

/**
 * Временная заглушка для initPopup
 */
class initPopup {
    static getConfig(selector, options = {}) {
        console.log('Нужно сделать реализацию initPopup.getConfig');
        console.log('Полученные параметры:', { selector, options });
        return {
            type: 'inline',
            items: {
                src: selector
            },
            ...options
        };
    }
}

/**
 * TextPagePartnersV1 widget configs
 */
const textPagePartnersV1Semantics = {
    'mainWrapClass': 'text-page-partners-v1',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'configClass': 'text-page-partners-v1__config',
    'typesButtonClass': 'text-page-partners-v1-types__button_type',
    'typesImageClass': 'text-page-partners-v1-types__image',
    'typesTitleClass': 'text-page-partners-v1-types__title',
    'partnersListClass': 'js-partners-types__list',
    'successButtonClass': 'text-page-partners-v1-types__button_success',
    'popupButtonClass': 'js-partners-popup-button',
    'popupClass': 'js-partners-popup',
    'formClass': 'js-partners-form',
    'selectTypeClass': 'js-partners-select-type',
    'popupItemsClass': 'js-partners-popup__items'
};

/**
 * TextPagePartnersV1 initializer
 */
$(function() {
    if ($(`.${textPagePartnersV1Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    window.widgets.textPagePartnersV1 = new TextPagePartnersV1();

    $(`.${textPagePartnersV1Semantics.mainWrapClass}`).each((index, el) => {
        let isInitialized = ($(el).attr(`${textPagePartnersV1Semantics.isInitializedAttribute}`) === 'true');
        if (!isInitialized) {
            let e = $(el);
            window.widgets.textPagePartnersV1.registerInstance(e);
            window.widgets.textPagePartnersV1.registerListeners(e);
            window.widgets.textPagePartnersV1.prepareConfig(e);
        }
    });
});

class TextPagePartnersV1 {
    constructor() {
        this.pluginInstances = {};
        this.config = null;
    }

    registerInstance(el) {
        let instanceId = el.attr(`${textPagePartnersV1Semantics.instanceIdAttribute}`) || false;
        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for instance with id [${instanceId}]`);
        }
        el.attr(`${textPagePartnersV1Semantics.isInitializedAttribute}`, true);
        this.pluginInstances[instanceId] = el;
    }

    registerListeners(el) {
        const $body = $('body');
        const that = this;

        $body.on('click', `.${textPagePartnersV1Semantics.typesButtonClass}`, function() {
            that.handleTypeButtonClick($(this));
        });

        $body.on('click', `.${textPagePartnersV1Semantics.popupButtonClass}`, function() {
            that.handlePopupButtonClick($(this));
        });

        $body.on('change', `.${textPagePartnersV1Semantics.selectTypeClass}`, function() {
            that.updatePopupList();
        });

        $body.on('submit', `.${textPagePartnersV1Semantics.formClass}`, function(e) {
            that.handleFormSubmit(e, $(this));
        });
    }

    handleTypeButtonClick($button) {
        const type = $button.data('type');

        $(`.${textPagePartnersV1Semantics.typesButtonClass}`)
            .removeClass('_active')
            .addClass('_muted');
        $button.removeClass('_muted').addClass('_active');

        $(`.${textPagePartnersV1Semantics.typesImageClass}, .${textPagePartnersV1Semantics.typesTitleClass}`)
            .removeClass('_active');

        $(`.${textPagePartnersV1Semantics.typesImageClass}_${type}`).addClass('_active');

        $(`.${textPagePartnersV1Semantics.partnersListClass}`).removeClass('_active');
        $(`.${textPagePartnersV1Semantics.partnersListClass}_${type}`).addClass('_active');

        $(`.${textPagePartnersV1Semantics.successButtonClass}`).data('type', $button.data('value'));

        this.showPartnersTypeList($(`.${textPagePartnersV1Semantics.partnersListClass}_${type}`));
    }

    handlePopupButtonClick($button) {
        const type = $button.data('type');
        const config = initPopup.getConfig(`.${textPagePartnersV1Semantics.popupClass}`, {
            callbacks: {
                open: () => {
                    $(`.${textPagePartnersV1Semantics.formClass}`)[0].reset();
                    if (type) {
                        $(`.${textPagePartnersV1Semantics.popupClass}`)
                            .find(`.${textPagePartnersV1Semantics.selectTypeClass}`)
                            .val(type);
                    }
                    this.updatePopupList();
                }
            },
        });
        $.magnificPopup.open(config);
    }

    handleFormSubmit(e, $form) {
        e.preventDefault();
        let emptyCount = 0;

        $form.find('[aria-required="true"]').each(function() {
            if (!$(this).val()) {
                emptyCount++;
            }
        });

        if (emptyCount) {
            $form.yiiActiveForm('validate', true);
            return false;
        }

        $.post($form.action, $form.serializeArray(), (res) => {
            const popup = $form.closest('.popup');
            if (res.success) {
                $.magnificPopup.open(initPopup.getConfig(popup.find('.js-success-popup')));
            } else {
                $.magnificPopup.open(initPopup.getConfig(popup.find('.js-error-popup')));
            }
        });
    }

    showPartnersTypeList($list) {
        $list.find('li').each((i, el) => {
            setTimeout(() => {
                $(el).addClass('_active');
            }, 500 * i);
        });

        setTimeout(() => {
            $(`.${textPagePartnersV1Semantics.successButtonClass}`).addClass('_show');
        }, 500 * $list.find('li').length);
    }

    updatePopupList() {
        const type = $(`.${textPagePartnersV1Semantics.selectTypeClass}`).val().replace(/\s/g, '');
        $(`.${textPagePartnersV1Semantics.popupItemsClass}`).hide();
        $(`.${textPagePartnersV1Semantics.popupItemsClass}_${type}`).show();
    }

    prepareConfig(el) {
        this.config = el.find(`.${textPagePartnersV1Semantics.configClass}`).data('config');
    }
}

export default TextPagePartnersV1;